import { render, staticRenderFns } from "./index-brief.vue?vue&type=template&id=53d3571c&scoped=true&"
import script from "./index-brief.vue?vue&type=script&lang=js&"
export * from "./index-brief.vue?vue&type=script&lang=js&"
import style0 from "./index-brief.vue?vue&type=style&index=0&id=53d3571c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3571c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('53d3571c', component.options)
    } else {
      api.reload('53d3571c', component.options)
    }
    module.hot.accept("./index-brief.vue?vue&type=template&id=53d3571c&scoped=true&", function () {
      api.rerender('53d3571c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analysis/index-brief.vue"
export default component.exports